module.exports = __webpack_public_path__ + "img/errorpageCircle.01bb15f8.svg";